var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5V17.5C30 20.1522 28.9465 22.6957 27.071 24.571C25.1957 26.4465 22.6522 27.5 20 27.5C17.3478 27.5 14.8043 26.4465 12.9289 24.571C11.0536 22.6957 10 20.1522 10 17.5V12.5C10 12.5 12.5 14.1667 20 14.1667C27.5 14.1667 30 12.5 30 12.5Z",
    fill: "#FFDDA1",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.667C21.7788 22.208 20.9015 22.5003 20 22.5003C19.0985 22.5003 18.2212 22.208 17.5 21.667",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 17.9163C16.4365 17.9163 16.25 17.7298 16.25 17.4997C16.25 17.2695 16.4365 17.083 16.6667 17.083",
    stroke: "#191919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 17.9163C16.8972 17.9163 17.0837 17.7298 17.0837 17.4997C17.0837 17.2695 16.8972 17.083 16.667 17.083",
    stroke: "#191919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 17.9163C23.1035 17.9163 22.917 17.7298 22.917 17.4997C22.917 17.2695 23.1035 17.083 23.3337 17.083",
    stroke: "#191919"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 17.9163C23.5632 17.9163 23.7497 17.7298 23.7497 17.4997C23.7497 17.2695 23.5632 17.083 23.333 17.083",
    stroke: "#191919"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.90039V12.5004C30 12.5004 27.5 14.1671 20 14.1671C12.5 14.1671 10 12.5004 10 12.5004V6.90039L19.6333 9.08372C19.8752 9.13371 20.1248 9.13371 20.3667 9.08372L30 6.90039Z",
    fill: "#808080",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5503 5.39974L30.0003 6.89974L20.367 9.08307C20.1251 9.13305 19.8755 9.13305 19.6336 9.08307L10.0003 6.89974L3.45027 5.39974C3.35816 5.38084 3.27537 5.3307 3.21592 5.25782C3.15649 5.18494 3.12402 5.09379 3.12402 4.99974C3.12402 4.90569 3.15649 4.81452 3.21592 4.74164C3.27537 4.66875 3.35816 4.61864 3.45027 4.59974L19.6336 0.916399C19.8755 0.866409 20.1251 0.866409 20.367 0.916399L36.5503 4.59974C36.6425 4.61864 36.7251 4.66875 36.7846 4.74164C36.8441 4.81452 36.8765 4.90569 36.8765 4.99974C36.8765 5.09379 36.8441 5.18494 36.7846 5.25782C36.7251 5.3307 36.6425 5.38084 36.5503 5.39974Z",
    fill: "#B2B2B2",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 5.36035V14.1637",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99966 20.8337C5.10882 18.4962 4.52929 16.1781 3.33299 14.167C2.13671 16.1781 1.55718 18.4962 1.66633 20.8337H4.99966Z",
    fill: "#808080",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3337 39.1667V37.3233C38.3372 36.8155 38.2232 36.3135 38.0006 35.857C37.7779 35.4005 37.4527 35.0017 37.0504 34.6917C34.8337 33 29.5504 30 20.0004 30C10.4504 30 5.1754 33 2.9504 34.6917C2.54804 35.0017 2.22284 35.4005 2.0002 35.857C1.77757 36.3135 1.66356 36.8155 1.66707 37.3233V39.1667",
    fill: "#808080"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0504 34.69C34.8337 33 29.5504 30 20.0004 30C10.4504 30 5.1754 33 2.95039 34.69C2.54819 35.0005 2.22312 35.3997 2.00052 35.8565C1.77792 36.3132 1.6638 36.8152 1.66706 37.3233V39.1667H4.18707C6.88374 37.4767 11.8987 35.3333 20.0004 35.3333C28.1021 35.3333 33.1171 37.485 35.8137 39.1667H38.3337V37.3233C38.3371 36.8152 38.2229 36.3132 38.0002 35.8565C37.7777 35.3997 37.4526 35.0005 37.0504 34.69Z",
    fill: "#B2B2B2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6171 30.9482L20.5755 38.6149C20.4205 38.7626 20.2146 38.8451 20.0005 38.8451C19.7863 38.8451 19.5805 38.7626 19.4255 38.6149L11.3838 30.9482",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3337 39.1667V37.3233C38.3372 36.8155 38.2232 36.3135 38.0006 35.857C37.7779 35.4005 37.4527 35.0017 37.0504 34.6917C34.8337 33 29.5504 30 20.0004 30C10.4504 30 5.1754 33 2.9504 34.6917C2.54804 35.0017 2.22284 35.4005 2.0002 35.857C1.77757 36.3135 1.66356 36.8155 1.66707 37.3233V39.1667",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6171 30.9501L20.5838 38.6168C20.428 38.7694 20.2186 38.8549 20.0005 38.8549C19.7823 38.8549 19.573 38.7694 19.4171 38.6168L11.3838 30.9501C14.2089 30.2969 17.101 29.9781 20.0005 30.0001C22.9 29.9781 25.7921 30.2969 28.6171 30.9501Z",
    fill: "#FFDDA1",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.bbdb6588c5d71c4229b6b10976332bb6.svg";
export { ForwardRef as ReactComponent };